import React, { useCallback, useEffect, useState } from "react";
import { Container } from "reactstrap";
import { useParams } from "react-router-dom";
import PageLoader from "components/common/PageLoader";
import BreadCrumb from "components/common/BreadCrumb";
import { getDocumentTitle } from "utils/helpers";
import { getPayment } from "features/Payments/services/PaymentService";
import type { Payment } from "features/Payments/types/payment.types";
import PaymentOverviewContext from "./PaymentOverviewContext";
import Section from "./Section";

const PaymentOverview = () => {
  document.title = getDocumentTitle("Payment details");
  const { id } = useParams();
  const [payment, setPayment] = useState<Payment | null>(null);
  const [loading, setLoading] = useState(true);

  const refetch = useCallback(async () => {
    if (!id) return;
    const numericId = Number(id);
    try {
      const res = await getPayment(numericId);
      if (res.success) {
        setPayment(res.data);
      } else {
        setPayment(null);
      }
    } catch (err) {
      console.warn(err);
      setPayment(null);
    }
  }, [id]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      setLoading(true);
      await refetch();
      if (!cancelled) setLoading(false);
    };

    void load();
    return () => {
      cancelled = true;
    };
  }, [id, refetch]);

  if (loading) {
    return <PageLoader message="Loading payment…" />;
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Payment details"
          pageTitle="Finance"
          items={[{ label: "Payments", path: "/finance/payments" }]}
        />
        <PaymentOverviewContext.Provider value={{ payment, refetch }}>
          <Section />
        </PaymentOverviewContext.Provider>
      </Container>
    </div>
  );
};

export default PaymentOverview;
